import { Outlet, useLocation } from 'react-router-dom';
import { PublicFooter } from '../components/landing/PublicFooter';

const footerPaths = [
  '/platform',
  '/who-its-for',
  '/about-us',
  '/contact-us',
  '/terms-of-service',
  '/data-processing-addendum',
  '/news-and-updates',
];

export function PublicLayout() {
  const { pathname } = useLocation();
  const showFooter = footerPaths.some((path) => pathname === path || pathname.startsWith(`${path}/`));

  return <div className={showFooter ? 'public-layout public-layout--with-footer' : undefined}><div className={showFooter ? 'public-layout-content' : undefined}><Outlet /></div>{showFooter && <PublicFooter />}</div>;
}
